export default __webpack_public_path__ + "static/media/pot5.46889ea3.svg";